import styled from 'styled-components';

interface ContainerProps {
	variant: 'total' | 'detail';
}

export const Container = styled.div<ContainerProps>`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: ${({ variant }) => variant === 'total' && '20px'};
`;
